import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const crop2xBaseURL = process.env.REACT_APP_CROP_2X_BASE_URL;
const baseURL = process.env.REACT_APP_MTA_WEB_VIEW_BASE_URL_DEVELOPMENT;

// ================================== | Get All Farms | ==================================
export const getAllFarms = createAsyncThunk(
    "MarketPlace/getAllFarms",
    async (msisdn) => {
        try {
            const response = await axios.post(`${crop2xBaseURL}/telenor/fields/get`, {
                msisdn
            });
            // console.log("GET ALL FARMS - RESPONSE:::::::::::::::::", response.data.data);
            return response.data.data;
        } catch (error) {
            console.log("ERROR", error);
        }
    }
);

// ================================== | Save Farm | ==================================
export const saveFarm = createAsyncThunk(
    "MarketPlace/saveFarm",
    async (payload) => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.post(`${crop2xBaseURL}/telenor/fields`, payload);
            // console.log("SAVE FARM - RESPONSE:::::::::::::::::", response.data);
            payload.area = parseInt(payload.area);
            const res = await axios.post(`${baseURL}/farm`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            // console.log("FARM SAVED TO STAGING DB - RESPONSE:::::::::::::::::", res.data);
            return response.data;
        } catch (error) {
            console.log("ERROR", error);
            throw error;
        }
    }
);

// ================================== | Generate Report | ==================================
export const generateFarmReport = createAsyncThunk(
    "MarketPlace/generateFarmReport",
    async (payload) => {
        try {
            const response = await axios.post(`${crop2xBaseURL}/telenor/start_report`, payload);
            // console.log("GENERATE FARM REPORT - RESPONSE:::::::::::::::::", response.data);
            return response.data;
        } catch (error) {
            console.log("ERROR", error);
            throw error;
        }
    }
);

// ================================== | Delete Report | ==================================
export const deleteFarmReport = createAsyncThunk(
    "MarketPlace/deleteFarmReport",
    async (payload) => {
        try {
            const response = await axios.post(`${crop2xBaseURL}/telenor/fields/delete`, payload);
            // console.log("DELETE FARM REPORT - RESPONSE:::::::::::::::::", response.data);
            return response.data;
        } catch (error) {
            console.log("ERROR", error);
            throw error;
        }
    }
);

// ================================== | Get Farmer Disctrict | ==================================
export const getFarmerDistrict = createAsyncThunk(
    "MarketPlace/getFarmerDistrict",
    async ({lat, lng}) => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(`${baseURL}/sites/district/${lat}/${lng}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            // console.log("GET FARMER DISTRICT - RESPONSE:::::::::::::::::", response.data);
            return response.data.data;
        } catch (error) {
            console.log("ERROR", error);
            throw error;
        }
    }
);
export const FarmSlice = createSlice({
    name: "Farm",
    initialState: {
        // ==================================================================================== //
        // ================================= | Data from DB | ================================= //
        // ==================================================================================== //
        allFarms: [], // ================ All Farms from DB
        farmReport: null, // ================ Farm Report Data
        farmerDistrictUrdu: null, // ================ Farmer District Data
        farmerDistrictEnglish: null, // ================ Farmer District Data
        // ==================================================================================== //
        // =================================== | loading | ==================================== //
        // ==================================================================================== //
        isFarmsLoading: false,
        isFarmReportLoading: false,
        isFarmerDistrictLoading: false,
        // ==================================================================================== //
        // ================================== | selections | ================================== //
        // ==================================================================================== //
        farmPoints: [], // ================ Farm Points Data
    },
    reducers: {
        // ==================================================================================== //
        // ================================= | Data from DB | ================================= //
        // ==================================================================================== //
        setReportEmpty: (state) => {
            state.farmReport = null;
        },
        // ==================================================================================== //
        // ================================== | selections | ================================== //
        // ==================================================================================== //
        setFarmPoints: (state, action) => {
            state.farmPoints = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // ==================================================================================== //
            // ================================== | Categories | ================================== //
            // ==================================================================================== //
            .addCase(getAllFarms.pending, (state) => {
                state.isFarmsLoading = true;
            })
            .addCase(getAllFarms.fulfilled, (state, action) => {
                state.allFarms = action.payload;
                state.isFarmsLoading = false;
            })
            .addCase(getAllFarms.rejected, (state) => {
                state.isFarmsLoading = false;
            })
            // ==================================================================================== //
            // ================================== | Save Farm | =================================== //
            // ==================================================================================== //
            .addCase(saveFarm.pending, (state) => {
                state.isFarmsLoading = true;
            })
            .addCase(saveFarm.fulfilled, (state) => {
                state.isFarmsLoading = false;
            })
            .addCase(saveFarm.rejected, (state) => {
                state.isFarmsLoading = false;
            })
            // ==================================================================================== //
            // ================================== | Generate Farm Report | ======================== //
            // ==================================================================================== //
            .addCase(generateFarmReport.pending, (state) => {
                state.isFarmReportLoading = true;
            })
            .addCase(generateFarmReport.fulfilled, (state, action) => {
                state.farmReport = action.payload;
                state.isFarmReportLoading = false;
            })
            .addCase(generateFarmReport.rejected, (state) => {
                state.isFarmReportLoading = false;
            })
            // ==================================================================================== //
            // ================================== | Get Farmer District | ========================= //
            // ==================================================================================== //
            .addCase(getFarmerDistrict.pending, (state) => {
                state.isFarmerDistrictLoading = true;
            })
            .addCase(getFarmerDistrict.fulfilled, (state, action) => {
                state.farmerDistrictUrdu = action.payload.districtUrdu;
                state.farmerDistrictEnglish = action.payload.district;
                state.isFarmerDistrictLoading = false;
            })
            .addCase(getFarmerDistrict.rejected, (state) => {
                state.isFarmerDistrictLoading = false;
            });
    }
});

export const {
    // ==================================================================================== //
    // ================================= | Data from DB | ================================= //
    // ==================================================================================== //
    setReportEmpty,
    // ==================================================================================== //
    // ================================== | Selection | =================================== //
    // ==================================================================================== //
    setFarmPoints,
} = FarmSlice.actions;

export default FarmSlice.reducer;
